import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import BooksOutlineButton from '../buttons/BooksOutlineButton';

import css from './BooksSelectTimeAvailability.module.scss';

interface Props {
  className?: string;
  value: string;
  reservable: boolean;
  postable: boolean;
  onClick: () => void;
}

const BooksSelectTimeAvailability = ({
  className,
  value,
  reservable,
  postable,
  onClick,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksSelectTimeAvailability, className);

  return (
    <div className={classes}>
      <div className={css.BooksSelectTimeAvailability__Item}>
        <div className={css.BooksSelectTimeAvailability__Menu}>
          {`${value} ~`}
        </div>
        <BooksOutlineButton
          className={css.BooksSelectTimeAvailability__Button}
          onClick={onClick}
          disabled={!reservable || !postable}
        >
          <span
            className={
              !reservable || postable
                ? undefined
                : css.BooksSelectTimeAvailability__Loading
            }
          >
            {intl.formatMessage({
              id: reservable
                ? 'books.button.select'
                : 'books.button.unselectable',
            })}
          </span>
        </BooksOutlineButton>
      </div>
    </div>
  );
};

export default injectIntl(BooksSelectTimeAvailability);
